var map = {
	"./alarm-clock.png": 522,
	"./amy.png": 1656,
	"./arrow-left.png": 523,
	"./arrow-right.png": 524,
	"./atty-general.png": 1657,
	"./checked-checkbox.png": 525,
	"./clever-share-settings.png": 1658,
	"./clever-share.png": 1659,
	"./collaboration-icon.png": 526,
	"./compare.png": 1661,
	"./coppa.png": 1662,
	"./dashboard-activities.png": 1663,
	"./dashboard-grading.png": 1664,
	"./dashboard-roster.png": 1665,
	"./data.png": 1666,
	"./december-sale-banner.png": 527,
	"./district.png": 1667,
	"./envelope.png": 1668,
	"./film-complete.png": 1669,
	"./film.png": 1670,
	"./google-classroom.png": 528,
	"./group-insights.png": 1671,
	"./halloween-sale-banner.png": 308,
	"./house.png": 1672,
	"./individual-insights.png": 1673,
	"./interior1.png": 1674,
	"./july-sale-banner.png": 529,
	"./lightbulb-off.png": 1675,
	"./lightbulb-on.png": 1676,
	"./main-ideas-icon.png": 1677,
	"./monkey.png": 530,
	"./new-year-sale-banner.png": 531,
	"./note-sm.png": 1678,
	"./presentation.png": 1679,
	"./quiz-complete.png": 532,
	"./quiz-draft.png": 533,
	"./quotes-2.png": 1680,
	"./sample-activities.png": 1681,
	"./school-and-owls.png": 534,
	"./september-sale-banner.png": 535,
	"./speech-to-text.png": 189,
	"./text-to-speech.png": 309,
	"./text_to_speech_keyboard.png": 536,
	"./unchecked-checkbox.png": 537,
	"./watch-icon.png": 1685,
	"./wise-owl-wizard.png": 538,
	"./wise-owls.png": 539
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 693;



//////////////////
// WEBPACK FOOTER
// ./assets/images/misc .*\.png
// module id = 693
// module chunks = 0